export const NEWSLETTER_SIGNUP_LOAD = 'NEWSLETTER_SIGNUP_LOAD';
export const NEWSLETTER_SIGNUP_MESSAGE = 'NEWSLETTER_SIGNUP_MESSAGE';
export const NEWSLETTER_SIGNUP_ERROR = 'NEWSLETTER_SIGNUP_ERROR';
